module.exports = __webpack_public_path__ + "static/media/logo.3fcd6e2f.svg";